// Typelizer digest ff16b6f2be6ad86538fc47422aa54224
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/ledger/documents */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/documents', {}, options),
    method: 'get',
  }),

  /** GET /c/:company_id/ledger/documents/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/documents/:id', params, options),
    method: 'get',
  }),
}
